export default __webpack_public_path__ + "static/media/drag.c3e6f8f5.svg";